
// @ts-nocheck
import Vue from 'vue';
import Dropzone from 'nuxt-dropzone';

export default Vue.extend({
  components: {
    Dropzone,
  },
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    placeholder: { type: String, required: true },
    initialErrors: {
      type: Array,
      default: () => [],
    },
    isRequired: {
      type: Boolean,
    },
    errorMessages: {
      type: Object,
    },
    uploadOptions: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      dropzoneOptions: {
        url: (): void => {},
        maxFilesize: 10,
        disablePreviews: true,
        acceptedFiles: 'image/jpeg,image/png,application/pdf',
        createImageThumbnails: false,
        dictRemoveFile: '',
        dictCancelUpload: '',
        dictFileTooBig: 'Datei ist zu groß.',
        addRemoveLinks: true,
        autoProcessQueue: false,
        ...this.uploadOptions,
      },
      errors: [] as Array<string>,
      uploadCount: 0,
    };
  },
  mounted() {
    window.addEventListener('validateForm', (e: Event) => {
      this.validate();
    });
    window.addEventListener('validateField', (e: Event) => {
      if (e.target === this.$refs.dropzone) {
        this.validate();
      }
    });

    // check for storybook initial errors
    if (this.initialErrors.length) {
      this.errors = (this.initialErrors as Array<string>).map(item => item);
    }
  },
  destroyed() {
    window.removeEventListener('validateForm', this.validate);
    window.removeEventListener('validateField', this.validate);
  },
  methods: {
    validate() {
      if (this.isRequired && !this.uploadCount) {
        this.errors = [this.errorMessages.required];
      } else {
        this.errors = [];
      }
    },
    async onSuccess(file: any) {
      setTimeout(() => {
        if (file.status !== 'error') {
          this.uploadCount++;
          this.$root.$emit('addFile', file);
          this.validate();
        }
      }, 200);
    },
    onError(file: any) {
      if (this.isRequired) {
        this.errors = [this.errorMessages.required];
      }
    },
    onRemove(file: any) {
      if (file.status !== 'error') {
        this.uploadCount--;
        this.$root.$emit('removeFile', file);
      }
      this.validate();
    },
  },
  computed: {
    isValid() {
      if (this.isRequired) return this.errors.length === 0 && this.uploadCount > 0;
      return true;
    },
  },
});
